/* eslint-disable max-len */
import React from 'react';

const CBCIcon = (props) => (
  <svg width='78' height='41' viewBox='0 0 78 41' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M23.6974 32.9269V29.0253H22.8609V30.5579H21.0183V29.0253H20.1877V32.9269H21.0183V31.2832H22.8609V32.9269H23.6974Z'
      fill='#4F5D68'
    />
    <path
      d='M26.3206 32.9971C27.4964 32.9971 28.3563 32.1548 28.3563 30.979C28.3563 29.8033 27.4964 28.9609 26.3206 28.9609C25.139 28.9609 24.2791 29.8033 24.2791 30.979C24.2791 32.1548 25.139 32.9971 26.3206 32.9971ZM26.3206 32.2601C25.5953 32.2601 25.1332 31.7044 25.1332 30.979C25.1332 30.2478 25.5953 29.698 26.3206 29.698C27.0401 29.698 27.5022 30.2478 27.5022 30.979C27.5022 31.7044 27.0401 32.2601 26.3206 32.2601Z'
      fill='#4F5D68'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M32.4321 6.96774L35.5161 8.74695L36.7369 6.63091L34.8811 5.56028L40.0942 2.56427L38.8784 0.445312L32.4235 4.14246L26.2077 0.556374L19.8585 4.15167L13.3503 0.553014L7.26324 4.22088L1.62791 0.910121L0.390442 3.01645L5.89506 6.25042V12.7275L8.3369 12.7794L8.61437 6.2589L13.4028 3.37356L19.8727 6.95105L26.1964 3.3702L29.9855 5.55621L24.9806 8.4326V17.3264L31.1999 20.9145V26.9953L28.3267 28.7015L29.574 30.802L32.4477 29.0955L37.6533 31.9282V35.2484H40.0963V31.926L45.284 29.0851L51.6275 32.6008L57.8979 29.0832L64.467 32.5969L70.633 29.0952L76.2135 32.2644L77.4199 30.1401L70.633 26.2858L64.4317 29.8076L57.87 26.2978L51.6203 29.8037L46.509 26.971V20.9199L49.25 19.3625L48.0431 17.2384L45.2829 18.8068L40.0963 15.9047V12.7275H37.6533V15.9025L32.4325 18.8053L27.4235 15.9155V9.84626L32.4321 6.96774ZM33.6428 20.9275V26.9646L38.8729 29.8106L44.066 26.9668V20.9252L38.8729 18.0196L33.6428 20.9275Z'
      fill='#64737F'
    />
    <path
      d='M38.916 11.0858C40.1506 11.0858 41.0535 10.2013 41.0535 8.96672C41.0535 7.73213 40.1506 6.84766 38.916 6.84766C37.6753 6.84766 36.7724 7.73213 36.7724 8.96672C36.7724 10.2013 37.6753 11.0858 38.916 11.0858ZM38.916 10.3119C38.1544 10.3119 37.6692 9.72835 37.6692 8.96672C37.6692 8.19894 38.1544 7.62157 38.916 7.62157C39.6715 7.62157 40.1568 8.19894 40.1568 8.96672C40.1568 9.72835 39.6715 10.3119 38.916 10.3119Z'
      fill='#4F5D68'
    />
    <path
      d='M40.7102 40.4842V36.4883H39.8535V38.0579H37.9664V36.4883H37.1157V40.4842H37.9664V38.8008H39.8535V40.4842H40.7102Z'
      fill='#4F5D68'
    />
    <path
      d='M53.6725 18.3787V14.3828H52.8158V15.9524H50.9286V14.3828H50.0779V18.3787H50.9286V16.6953H52.8158V18.3787H53.6725Z'
      fill='#4F5D68'
    />
  </svg>
);
export default CBCIcon;
